/** @jsx jsx */
import { jsx, css, keyframes } from "@emotion/core";
import Header from "./Header";
import React from 'react'


import Footer from "./Footer";

const pageTransition = keyframes`
    100% {
		opacity: 1;
	}
`;



const page = css`
          opacity: 0;
          color: #ffffff;
          min-height: 80%;
          animation: ${pageTransition} 800ms 200ms ease-in-out forwards;
        `

const Layout = props => {
  return (
    <>
      <Header noLinks={props.noLinks} />
      <main css={page}>{props.children}</main>
      <Footer />
    </>
  );
};

export default Layout;
